import DashedLine from "features/CenterContent/VehicleDetails/shared/DashedLine";
import { Children } from "react";
import { SegmentedPanel } from "shared/components/SegmentedPanel";
import { Box, Flex, HStack, VStack } from "shared/components/Spor";
import { VariantColor } from "shared/utils/colorUtils";
import { FCWC } from "shared/utils/FCWC";
import { RuleSet } from "styled-components";
/**
 * Splits the `children` into:
 * child1 child2
 *  - -    - -
 * ╭---╮  ╭---╮
 * ╰---╯  |   |
 *  - -   |   |
 * ╭---╮  |   |
 * ╰---╯  ╰---╯
 * Thus dividing (horizontally) first and then in <SegmentedPanel/>
 * In this example `children` consist of 2 childs; where child1 has 2 children and child2 has 1 child.
 */
type SegmentedPanelMatrixProps = {
  panelStyle: RuleSet<object>; // Aka: css`xxx`
  variant: VariantColor;
  noDashedLineGaps?: boolean; // Since DashedLineGaps must be applied directly near children (React limitation), this should likely always be true
};

export const SegmentedPanelMatrix: FCWC<SegmentedPanelMatrixProps> = ({
  children,
  panelStyle,
  variant,
  noDashedLineGaps,
}) => (
  /* maxH is adjusted for StepActionModal */
  <Flex maxH="45vh">
    <HStack alignItems="stretch" flex={1} gap="3px" overflowY="scroll">
      {Children.toArray(children).map((it, i) => (
        <VStack
          // eslint-disable-next-line react/no-array-index-key -- Generic component, so we dont have anything else to go by. These should not be reordered
          key={`segmented_panel_${i}`}
          alignItems="stretch"
          flex={1}
          gap="0px"
        >
          <DashedLine variant={variant} />
          <SegmentedPanel
            panelStyle={panelStyle}
            dashedLineVariant={variant}
            noDashedLineGaps={noDashedLineGaps}
          >
            {it}
          </SegmentedPanel>
        </VStack>
      ))}
    </HStack>
  </Flex>
);
export const EmptySegmentedPanel = () => (
  <Box flex={1} padding="0px !important" />
);
